export default "__VITE_ASSET__afd2f4a0__"